import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import { createNumberMask } from 'redux-form-input-masks';
import { BodyText, TextInput, Tooltip } from '@swift-paypal/pp-react';
import { TOOLTIP_DESCRIPTION, TOOLTIP_NAME } from './covered-worker-protection-expenditures-constants';
import constants from '../../../../../constants';

// eslint-disable-next-line react/prop-types
const MappedInput = ({ input, ...props }) => <TextInput {...input} {...props} />;

const currencyMask = createNumberMask({
  allowEmpty: true,
  prefix: '$',
  decimalPlaces: 2,
  locale: 'en-US',
});

const CoveredWorkerProtectionExpenditures = ({
  className, error, submitted, touched, value,
}) => (
  <>
    <BodyText as="label" htmlFor="coveredWorkerProtectionExpenditures">
      Covered worker protection expenditures
    </BodyText>
    <Field
      className={className}
      key="covered-worker-protection-expenditures"
      name="coveredWorkerProtectionExpenditures"
      errorText={submitted || touched ? error : undefined}
      component={MappedInput}
      rightIcon={<Tooltip description={TOOLTIP_DESCRIPTION} name={TOOLTIP_NAME} />}
      type="tel"
      placeholder="$"
      value={value}
      validate={[required({ msg: constants.errors.currencyZeroError })]}
      {...currencyMask}
    />
  </>
);

CoveredWorkerProtectionExpenditures.defaultProps = {
  className: undefined,
  error: undefined,
  submitted: false,
  touched: false,
  value: undefined,
};

CoveredWorkerProtectionExpenditures.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  submitted: PropTypes.bool,
  touched: PropTypes.bool,
  value: PropTypes.number,
};

export default memo(CoveredWorkerProtectionExpenditures);
